package one.healthium.domain.paywall.models

import kotlinx.serialization.ExperimentalSerializationApi
import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable
import kotlinx.serialization.Transient
import kotlinx.serialization.json.JsonNames
import one.healthium.domain.common.ImageMode
import one.healthium.base.utils.DeviceClass.Default
import one.healthium.base.utils.DeviceClass.Low
import one.healthium.base.utils.DeviceClass.Mid
import one.healthium.base.utils.DeviceClass.Plus
import one.healthium.base.utils.DeviceClass.Promax
import one.healthium.base.utils.DeviceClass.i13Pro
import one.healthium.base.utils.DeviceClass.i14Pro

@OptIn(ExperimentalSerializationApi::class)
@Serializable
@SerialName("image")
data class PaywallImageView(
    @JsonNames("id") override val id: String,
    @SerialName("config") val config: PaywallImageConfig? = null,
    @SerialName("config_plus") val configPlus: PaywallImageConfig? = null,
    @SerialName("config_mid") val configMid: PaywallImageConfig? = null,
    @SerialName("config_low") val configLow: PaywallImageConfig? = null,
    @SerialName("config_13pro") val config13pro: PaywallImageConfig? = null,
    @SerialName("config_14pro") val config14pro: PaywallImageConfig? = null,
    @SerialName("config_promax") val configPromax: PaywallImageConfig? = null
) : PaywallScreenView {
    @Transient
    val configs = mapOf(
        Default to config,
        Plus to configPlus,
        Mid to configMid,
        Low to configLow,
        i13Pro to config13pro,
        i14Pro to config14pro,
        Promax to configPromax,
    )
}

@Serializable
data class PaywallImageConfig(
    @SerialName("image_name") val imageName: String? = null,
    @SerialName("content_mode") val contentMode: ImageMode? = null,
    @SerialName("height") val height: Int? = null,
)